import React, { FC, useEffect, useRef } from 'react';

export const ScrollHeader: FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const adjustHeaderSize = (el: HTMLDivElement) => {
    const boundaries = el.getBoundingClientRect();
    if (containerRef.current) {
      containerRef.current.style.width = document.documentElement.offsetWidth - boundaries.left + 'px';
    }
  };

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    const listener = () => {
      if (containerRef.current) {
        adjustHeaderSize(containerRef.current);
      }
    };
    listener();
    window.addEventListener('resize', listener);
    return () => {
      window.addEventListener('resize', listener);
    };
  });
  return (
    <div className="scrollHeader" ref={containerRef}>
      {children}
    </div>
  );
};
